import { Button } from "@mui/material";
import { GridToolbar } from "@progress/kendo-react-grid";

import { RefreshButton } from "../../../components/commons/RefreshButton";
import { ViewToggleButton } from "../../../components/commons/ViewToggleButton";
import { Activite } from "../../../models/Activite";
import { Banniere } from "../../../models/Banniere";
import { Collection } from "../../../models/Collection";
import { Division } from "../../../models/Division";
import { Fournisseur } from "../../../models/Fournisseur";
import { Magasin } from "../../../models/Magasin";
import { Section } from "../../../models/Section";
import { Statut } from "../../../models/Statut";
import { User } from "../../../models/User";
import { planoAPI } from "../../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import FiltersList from "./FiltersList";

interface ToolbarProps {
  setSelectedRow: React.Dispatch<React.SetStateAction<number | null>>;
  setOpenNewProduit: React.Dispatch<React.SetStateAction<boolean>>;
  setAddProductTitle: React.Dispatch<React.SetStateAction<string>>;
  user: User[];
  ban: Banniere[];
  mag: Magasin[];
  div: Division[];
  section: Section[];
  currentAcc: Activite[];
  statut: Statut[];
  four: Fournisseur[];
  collection: Collection[];
  setCollection: React.Dispatch<React.SetStateAction<string>>;
  setSection: React.Dispatch<React.SetStateAction<string>>;
  setDivision: React.Dispatch<React.SetStateAction<string>>;
  setBanniere: React.Dispatch<React.SetStateAction<string>>;
  setMagasin: React.Dispatch<React.SetStateAction<string>>;
  setFournisseur: React.Dispatch<React.SetStateAction<string>>;
  setStatut: React.Dispatch<React.SetStateAction<string>>;
  setActivite: React.Dispatch<React.SetStateAction<string>>;
  setAcheteur: React.Dispatch<React.SetStateAction<string>>;
  updateObject: any;
}

function Toolbar(props: ToolbarProps) {
  const dispatch = useAppDispatch();
  const prod_plano = useAppSelector((state) => state.appState.prod_plano);

  const invalidateQueries = () => {
    dispatch(planoAPI.util.invalidateTags(["planogramme", "plano"]));
  };

  return (
    <GridToolbar className="icon-toolbar">
      <div>
        <ViewToggleButton />
        <RefreshButton invalidateQueries={invalidateQueries} />
      </div>
      <FiltersList
        activites={props.currentAcc}
        bannieres={props.ban}
        divisions={props.div}
        magasins={props.mag}
        sections={props.section}
        statuts={props.statut}
        fournisseurs={props.four}
        acheteurs={props.user}
        collections={props.collection}
        setCollection={props.setCollection}
        setAcheteur={props.setAcheteur}
        setActivite={props.setActivite}
        setBanniere={props.setBanniere}
        setDivision={props.setDivision}
        setFournisseur={props.setFournisseur}
        setMagasin={props.setMagasin}
        setSection={props.setSection}
        setStatut={props.setStatut}
        updateObject={props.updateObject}
      />
      <Button
        onClick={() => {
          props.setSelectedRow(null);
          props.setOpenNewProduit(true);
          props.setAddProductTitle("Ajouter un nouveau produit");
        }}
        variant="contained"
        sx={{
          width: "275px",
          borderRadius: "30px",
          backgroundColor: "#007bff",
        }}
        disabled={!prod_plano.canAdd}
      >
        Ajouter un nouveau produit
      </Button>
    </GridToolbar>
  );
}

Toolbar.displayName = "KendoReactGridToolbar"; //Important sinon Kendo n'affiche pas le component'

export default Toolbar;
